import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from '@/api/PMS/customerService/complaintManage';
import waves from '@/directive/waves'; // 水波纹指令

import complaintDetail from '../complaintQuery/detail';
import complaintTransfer from '../complaintQuery/transfer';
import complaintDispose from '../complaintQuery/dispose';
export default {
  components: {
    complaintDetail: complaintDetail,
    complaintTransfer: complaintTransfer,
    complaintDispose: complaintDispose
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      complaintId: '',
      flowNum: '',
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        status: 1,
        pageTypePc: 2
      },
      complaintOption: [{
        name: '微信',
        value: 1
      }, {
        name: '电话',
        value: 2
      }, {
        name: '现场登记',
        value: 3
      }],
      situationOption: [{
        name: '紧急',
        value: 0
      }, {
        name: '一般',
        value: 1
      }],
      statusOption: [{
        name: '未处理',
        value: 1
      }, {
        name: '处理中',
        value: 2
      }, {
        name: '已处理',
        value: 3
      }],
      visitOption: [{
        name: '未回访',
        value: 1
      }, {
        name: '已回访',
        value: 2
      }],
      title: '',
      multipleSelection: [],
      dialogFormVisible: false,
      dialogFormDispatchVisible: false,
      dialogFormTransferVisible: false,
      dialogFormDisposeVisible: false,
      dialogFormReturnVisible: false
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      this.getList();
      this.dialogFormVisible = false;
      this.dialogFormDispatchVisible = false;
      this.dialogFormTransferVisible = false;
      this.dialogFormDisposeVisible = false;
      this.dialogFormReturnVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCheck: function handleCheck(id, flowNum) {
      this.complaintId = id;
      this.flowNum = flowNum;
      this.title = '投诉详情';
      this.dialogFormVisible = true;
    },
    getFlowDetail: function getFlowDetail(id, flowNum) {
      this.complaintId = id;
      this.flowNum = flowNum;
      this.dialogFormVisible = true;
      this.title = '投诉详情';
    },
    handleDispatch: function handleDispatch(id) {
      this.complaintId = id;
      this.title = '派工';
      this.dialogFormDispatchVisible = true;
    },
    handleTransfer: function handleTransfer(id) {
      this.complaintId = id;
      this.title = '转派';
      this.dialogFormTransferVisible = true;
    },
    handleDispose: function handleDispose(id) {
      this.complaintId = id;
      this.title = '处理';
      this.dialogFormDisposeVisible = true;
    },
    handleReturnVisit: function handleReturnVisit(id, flowNum) {
      this.complaintId = id;
      this.flowNum = flowNum;
      this.title = '新增客户回访';
      this.dialogFormReturnVisible = true;
    },
    delete: function _delete(posIds) {
      var _this2 = this;

      if (posIds.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          fetchDelete(posIds).then(function (response) {
            _this2.getList();

            _this2.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(posId) {
      var posIds = [];
      posIds.push(posId);
      this.delete(posIds);
    },
    handleDeletes: function handleDeletes() {
      var posIds = [];
      this.multipleSelection.forEach(function (row) {
        posIds.push(row.posId);
      });
      this.delete(posIds);
    }
  }
};